// Splash page scripts

gsap.set(".splash__logo", { y: -60, opacity: 0 });
gsap.set(".splash__video", { scale: 0.5, opacity: 0 });
gsap.set(".splash__cta", { scale: 0.5, opacity: 0 });

gsap.to(".splash__logo", { y: 0, opacity: 1,  duration: 1.3, ease: "elastic.out(0.2,0.1)" , delay: 0.5 } );
gsap.to(".splash__video", { scale: 1,opacity: 1, duration: 1.3, ease: "elastic.out(0.1,0.2)" , delay: 0.5 });
gsap.to(".splash__cta", { scale: 1, opacity: 1, duration: 0.5, ease: "back.out(1.7)", delay: 1.8 });

document.querySelector(".reveal-form__btn").addEventListener("click", function () {
  gsap.to([".splash__title", ".splash__button-wrap", ".splash__video"], {
    y: 60,
    opacity: 0,
    duration: 0.4,
    ease: "power2.out",
    stagger: 0.2,
     onComplete: () => {
      document.querySelector(".top").style.zIndex = "0";
    }
  });
  gsap.to(".form-outer-wrap", {
    y: 0,
    opacity: 1,
    pointerEvents: "auto",
    duration: 1.3,
    ease: "elastic.out(0.8,0.3)",
    delay: 0.7
  });
});

// Form submit
 // 1️⃣ Target the first child of form-outer-wrap
const klaviyoFormContainer = document.querySelector('.form-outer-wrap > .klaviyo-form-VFEceP');


// 3️⃣ Fallback: observe when the container has no children (after submission)
const observer = new MutationObserver((mutationsList, observer) => {
  mutationsList.forEach((mutation) => {
    if (mutation.type === 'childList') {
      if (klaviyoFormContainer.children.length === 0) {
        console.log('form submitted')
        hideFormShowSuccess()
      }
    }
  });
});

observer.observe(klaviyoFormContainer, { childList: true });

function hideFormShowSuccess() {
  // 1️⃣ Hide all form icons
  document.querySelectorAll(".form-icon").forEach(icon => {
    gsap.to(icon, { opacity: 0, duration: 0.5, pointerEvents: "none" });
  });

  const showFormBtn = document.querySelector('.splash__button-wrap')
  if(showFormBtn) {
    showFormBtn.style.display = "none";
  }

    // 2️⃣ Replace splash title text
  const splashTitle = document.querySelector(".splash__title");
  if (splashTitle) {
    splashTitle.classList.add("is-success-message");
    splashTitle.style.fontSize = window.innerWidth < 996 ? "37px" : "47px";
    splashTitle.innerHTML = "You’re on the list. <br> We will be in touch when the time is right.";
  }


  // 2️⃣ Reshow splash elements
  gsap.to([".splash__title", ".splash__video"], {
    y: 0,
    opacity: 1,
    duration: 0.6,
    ease: "power2.out",
    stagger: 0.1
  });

  // Optional: hide the form itself again
  gsap.to(".form-outer-wrap", {
    y: 200,
    opacity: 0,
    pointerEvents: "none",
    duration: 0.8,
    ease: "power2.inOut"
  });

  // Reset page after 10 seconds (e.g. for kiosk/TV loop)
  setTimeout(() => {
    location.reload();
  }, 6000);
}